const WEEKDAY_LEAD = /^(Sunday|Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|Sun|Mon|Tue|Wed|Thu|Fri|Sat)\b[,]?\s*/i;
const STALE_MS = 3 * 24 * 60 * 60 * 1000;

export function lastUpdateMillis(value) {
  let text = String(value ?? "").trim();
  if (!text) return null;
  text = text.replace(WEEKDAY_LEAD, "").replace(/\bGMT(?:\s*\([^)]*\))?\b/gi, " ").replace(/\s+/g, " ").trim();
  const direct = Date.parse(text);
  if (!Number.isNaN(direct)) return direct;
  const yearAtEnd = text.match(/^(.*\D)(\d{4})$/);
  if (yearAtEnd) {
    const moved = Date.parse(`${yearAtEnd[2]} ${yearAtEnd[1]}`);
    if (!Number.isNaN(moved)) return moved;
  }
  return null;
}

export function reportIsStale(stamp) {
  const parsed = lastUpdateMillis(stamp);
  if (parsed == null) return false;
  return Date.now() - parsed > STALE_MS;
}
